import { render } from "./PreencherTask.vue?vue&type=template&id=26d51620&scoped=true"
import script from "./PreencherTask.vue?vue&type=script&lang=js"
export * from "./PreencherTask.vue?vue&type=script&lang=js"

import "./PreencherTask.vue?vue&type=style&index=0&id=26d51620&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-26d51620"]])

export default __exports__